<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 283.46 113.39"
    :width="props.width"
    :height="props.height"
    :style="{ fill: props.fill }"
  >
    <path
      :class="{ st0: !props.fill }"
      d="M31.23,47.88h9.7l9.82,20.18h-9.7l-.84-2.32h-8.24l-.84,2.32h-9.7l9.82-20.18ZM36.11,53.99h-.06l-2.35,6.84h4.76l-2.35-6.84Z"
    />
    <g>
      <path
        :class="{ st0: !props.fill }"
        d="M52.87,47.88h16.31c5.61,0,7.68,2.54,7.68,7.04,0,3.87-2.02,6.87-7.62,6.87h-8.46v6.27h-7.9v-20.18ZM60.78,56.87h5.1c1.99,0,2.75-.62,2.75-2.09s-.76-2.15-2.75-2.15h-5.1v4.24Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M91.94,47.18c4.79,0,13.68.34,13.68,10.8s-8.88,10.8-13.68,10.8-13.68-.34-13.68-10.8,8.88-10.8,13.68-10.8M91.94,63.68c3.22,0,5.27-1.61,5.27-5.71s-2.05-5.71-5.27-5.71-5.27,1.61-5.27,5.71,2.05,5.71,5.27,5.71"
      />
    </g>
    <g>
      <path
        :class="{ st0: !props.fill }"
        d="M127.27,58.5h-13.79v9.53h-3.01v-20.25h3.01v8.11h13.79v-8.11h3.01v20.25h-3.01v-9.53Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M134.64,47.78h16.28v2.61h-13.28v5.87h12.88v2.61h-12.88v6.55h13.56v2.61h-16.57v-20.25Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M168.05,62.14h-9.93l-2.58,5.9h-3.23l9.16-20.25h3.43l9.16,20.25h-3.43l-2.58-5.9ZM163.06,50.56l-3.8,8.96h7.69l-3.89-8.96Z"
      />
      <path :class="{ st0: !props.fill }" d="M176.25,47.78h3.01v17.64h12.31v2.61h-15.32v-20.25Z" />
      <path
        :class="{ st0: !props.fill }"
        d="M196.38,50.39h-7.66v-2.61h18.32v2.61h-7.66v17.64h-3.01v-17.64Z"
      />
      <path
        :class="{ st0: !props.fill }"
        d="M226.05,58.5h-13.79v9.53h-3.01v-20.25h3.01v8.11h13.79v-8.11h3.01v20.25h-3.01v-9.53Z"
      />
    </g>
    <path
      :class="{ st0: !props.fill }"
      d="M203.96,73.6l1.25,3.9c.15.46.31.91.47,1.37.04.1.07.2.11.31.13.35.26.7.39,1.05.13.35.27.7.42,1.05.09.23.19.46.28.69.25.6.52,1.19.81,1.79.07.14.14.29.21.43.24.5.49,1,.76,1.5.08.15.16.3.24.45.33.61.67,1.22,1.03,1.83.01.02.02.03.03.05.33.56.68,1.11,1.04,1.67.15.23.3.46.45.68.22.33.45.67.69,1,.19.27.37.53.56.79.22.3.45.6.68.9.17.23.33.46.51.68l.5.64h0s.02.02.02.02l.8-.18c6.13-1.38,11.84-3.77,16.97-7.11l3.43-2.23.79-.58c10.01-7.69,14.79-17.06,18.23-25.65l.13-.3,1.13-3.23c2.27-6.5,3.05-11.37,3.2-12.39.02-.12.03-.19.03-.2l.12-.93-.85-.4c-.06-.03-.12-.06-.18-.09-.45-.21-.9-.43-1.34-.65-.25-.13-.5-.25-.74-.38-.23-.12-.46-.24-.69-.36-.3-.16-.61-.32-.9-.48-.02,0-.03-.02-.05-.03-11.55-6.31-15.01-12.56-15.05-12.62l-.55-1.04-1.09.45s-.62.25-1.82.53c-.03,0-.06.01-.09.02-.24.05-.5.11-.78.16-.18.03-.36.07-.56.1-.11.02-.22.04-.33.06-.32.05-.66.1-1.02.15-.07,0-.14.02-.21.02-.38.04-.78.09-1.21.12-.03,0-.06,0-.1,0-.45.04-.93.06-1.43.09-.1,0-.2,0-.3.01-.49.02-1.01.03-1.55.03-.3,0-.61-.01-.91-.02-.28,0-.55,0-.84-.02-.4-.01-.8-.04-1.21-.06-.21-.01-.41-.02-.62-.04-.47-.03-.94-.08-1.41-.12-.13-.01-.26-.03-.39-.04-2.92-.31-5.97-.86-9.15-1.65l-.91-.23-.5.8c-.12.19-2.87,4.67-5.45,11.81l-1.16,3.22h.06s.04,0,.1,0h4.24l7.44-5.32s5.55.6,7.92.7c.06,0,.12,0,.18,0,.57.02,1.1.04,1.6.04.35,0,.69.01,1.02.01h0s.02,0,.03,0c2.69,0,4.95-.2,6.73-.46,1.44,1.57,3.11,3.13,4.96,4.64,2.06,1.67,5.41,4.13,8.8,6.19-.99,3.77-2.72,9.02-5.6,14.47-6.01,11.35-14.5,18.98-25.22,22.7l-9.23-10.32h-4.93"
    />
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height?: string
  width?: string
  fill?: string
}

const props = defineProps<SVGProps>()
</script>

<style scoped>
.st0 {
  fill: #231f20;
}
</style>
